import { useSatuEventTracker } from 'utils/satuEvent'
import { useAuth } from 'utils/auth'
import usePeriodContext from 'app/KinerjaShared/hooks/usePeriodContext'

const SATU_EVENT_NAME: string = 'penilaian_akhir_interaction_v1'
const DEFAULT_TIMEOUT: number = 5_000 // 5 seconds

const convertToKeyValuePairs = (
  obj: Record<string, any>
): { key: string; value: any }[] => {
  return Object.entries(obj).map(([key, value]) => ({
    key,
    value,
  }))
}

export const usePenetapanTrackEvent = () => {
  const { session } = useAuth()
  const { SETrackEvent } = useSatuEventTracker()
  const { period } = usePeriodContext()

  const trackEvent = (
    eventCategory: string,
    eventAction: string,
    eventLabel?: string,
    additionalParams: Record<string, any> = {}
  ): void => {
    SETrackEvent({
      eventName: SATU_EVENT_NAME,
      eventParams: {
        attributes: convertToKeyValuePairs({
          eventCategory,
          eventAction,
          ...(eventLabel ? { eventLabel } : {}),
        }),
        custom_dimension: convertToKeyValuePairs({
          email: session?.user?.email ?? null,
          periode_id: period.id,
          pengkin_type: 'ps',
          ...additionalParams,
        }),
      },
      timeout: DEFAULT_TIMEOUT,
      keepAlive: true,
      sendAttributes: false,
    })
  }

  return {
    trackEvent,
  }
}
